import Navigation from '../common/Navigation'; 
import MobileNavigation from '../common/MobileNavigation';
import { useState, useEffect } from "react";
import { SCREEN_SIZE } from '@src/config/constant';

const Header = () => {
    const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth < SCREEN_SIZE);

    const checkIfMobile = () => {
        setIsMobile(window.innerWidth < SCREEN_SIZE);
    };

    useEffect(() => {
        // Run once on mount
        setIsMobile(window.innerWidth < SCREEN_SIZE);
        
        window.addEventListener('resize', checkIfMobile);

        return () => {
            window.removeEventListener('resize', checkIfMobile);
        };
    }, []);

    return (
        <header>
            {isMobile ? <MobileNavigation /> : <Navigation />}
        </header>
    );
}

export default Header;
